import React, { useState, useContext } from 'react';
import Grid from '@mui/material/Grid';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';

import CustomRowLabels from './CustomRowLabels';
import CondenserDetailsSubsection from './CondenserDetailsSubSection';
import { ChillerLogsContext } from '../contexts/ChillerLogsContext';

interface CondenserDetailsSectionProps {}

const CondenserDetailsSection: React.FunctionComponent<CondenserDetailsSectionProps> = () => {
  let { chillerLog, prevChillerLog1, prevChillerLog2 } = useContext(ChillerLogsContext);

  let [expanded, setExpanded] = useState(true);

  let rowData = chillerLog?.circuits?.[0]?.condenser_details;
  let circuitsToDisplay = chillerLog?.circuits?.slice(0, chillerLog?.circuit_count);

  return (
    chillerLog && (
      <Accordion style={{ width: '100%' }} expanded={expanded} onChange={() => setExpanded(!expanded)}>
        <AccordionSummary style={{ background: '#A21C37' }}>
          <h3 style={{ color: '#fff', fontWeight: 700 }}>Condenser Details</h3>
        </AccordionSummary>
        <AccordionDetails style={{ margin: 0, padding: 0 }}>
          <Grid container>
            <Grid item xs={2} sx={{ minWidth: 200 }}>
              <Grid container>
                <CustomRowLabels data={rowData} />
              </Grid>
            </Grid>
            <Grid item xs={10} sx={{ minWidth: 250 }}>
              <Grid container spacing={0} sx={{ display: 'flex', flexWrap: 'nowrap' }}>
                {circuitsToDisplay?.map((circuit, index) => {
                  let prevCircuit2 = prevChillerLog2?.circuits?.[index];
                  let prevCircuit1 = prevChillerLog1?.circuits?.[index];
                  let currentCircuit = chillerLog?.circuits?.[index];

                  return (
                    <React.Fragment key={`circ-container-${index}`}>
                      {prevCircuit2 && (
                        <Grid item xs={1}>
                          <CondenserDetailsSubsection chillerCircuit={prevCircuit2} col={1} />
                        </Grid>
                      )}
                      {prevCircuit1 && (
                        <Grid item xs={1}>
                          <CondenserDetailsSubsection chillerCircuit={prevCircuit1} col={2} />
                        </Grid>
                      )}
                      <Grid item xs={1}>
                        <CondenserDetailsSubsection chillerCircuit={currentCircuit} col={3} />
                      </Grid>
                    </React.Fragment>
                  );
                })}
              </Grid>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    )
  );
};

export default CondenserDetailsSection;
